import { SET_NAV, SET_DEEDPRINT } from "./types";

export default {
  // 格式: mutation: storeKey
  [SET_NAV]: "NAV",
  [SET_DEEDPRINT]: "DEEDPRINT",
};
